import ispo from "lodash/isPlainObject";
const isArray = (value) => Array.isArray(value);
const isBoolean = (value) => typeof value === "boolean";
const isNil = (value) => value == null;
const isNumber = (value) => typeof value === "number" && Number.isFinite(value);
const isPlainObject = (obj) => ispo(obj);
const isString = (value) => typeof value === "string";
const isFunction = (value) => typeof value === "function";
const isPresent = (value) => value !== void 0 && value !== null;
const isDefined = (value) => value !== void 0;
const isNotNull = (value) => value !== null;
export {
  isArray,
  isBoolean,
  isDefined,
  isFunction,
  isNil,
  isNotNull,
  isNumber,
  isPlainObject,
  isPresent,
  isString
};
//# sourceMappingURL=type-guards.js.map
